import { useEffect, useMemo } from "react"

import { Collapse, Flex, Spin, Tag, Typography } from "antd"
import cls from "classname"
import { connect, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router"
import { useNavigate } from "react-router-dom"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"
import CreditsPage from "../CreditsPage"
import { AddCommentRequestModal } from "./components/Modal/AddCommentRequest"
// import RequestsDescriptors from './RequestsDescriptors'
import RequestsAutoRefund from "./RequestsAutoRefund"
import RequestsEnrollments from "./RequestsEnrollments"
import RequestsGifts from "./RequestsGifts"
import RequestsIntegrations from "./RequestsIntegrations"
import RequestsVerifiInform from "./RequestsVerifiInform"
import RequestsWithdrawal from "./RequestsWithdrawal"
import { useRequestsPageQuery } from "./useRequestsPageQuery"

import "../PersonalSettings/styles.less"
import "./styles.less"

const { Title, Text, Paragraph } = Typography

const tabsList = [
  {
    id: "enrollments",
    text: "Enrollments",
    icon: "piggy_bank",
    options: [
      { text: "Pending", id: "pending" },
      { text: "Needs assistance", id: "needs_assistance" },
      { text: "In progress", id: "in_progress" },
      { text: "Active", id: "active" },
      { text: "Failed", id: "failed" },
      { text: "Unenrolled", id: "unenrolled" },
      { text: "Pending Unenroll", id: "pending_unenroll" },
      { text: "Unassigned", id: "unassigned" },
      { text: "Archive", id: "archive" }
    ]
  },
  // {
  //   id: 'descriptors',
  //   text: 'Descriptors',
  //   icon: 'code_lines',
  //   options: [
  //     {text: 'New', id: 'new', key: 'general'},
  //     {text: 'Processed', id: 'processed'},
  //     {text: 'Archive', id: 'archive'},
  //     {text: 'Further Communication', id: 'need_communication'},
  //   ]
  // },
  {
    id: "auto_refund",
    text: "Auto-refund",
    icon: "money_hand",
    options: [
      { text: "New", id: "new", key: "general" },
      { text: "Processed", id: "processed" },
      { text: "Archive", id: "archive" }
    ]
  },
  {
    id: "integrations",
    text: "Integrations",
    icon: "list_sparkle"
  },
  {
    id: "credits",
    text: "Credits",
    icon: "piggy_bank",
    options: [
      { text: "Pending", id: "pending", key: "general" },
      { text: "Processed", id: "processed" },
      { text: "Completed", id: "completed" },
      { text: "Awaiting proof", id: "awaiting_proof" },
      { text: "Archive", id: "archive" }
    ]
  },
  {
    id: "gift",
    text: "Gifts",
    icon: "gift"
  },
  {
    id: "withdrawal",
    text: "Withdrawals",
    icon: "money_hand"
  },
  {
    id: "verifi_inform",
    text: "Verifi Inform",
    icon: "bank_card"
  }
]

const RequestsPage = ({ businessAccountFetching, statistics }) => {
  const { hash } = useParams() // enrollments, auto_refund, integrations, credits
  const { search } = useLocation()
  const { folder, addCommentRequestID } = useRequestsPageQuery(search)
  const navigate = useNavigate()
  const isRestrictedVerifiInformAdmin = useSelector((state) => state.auth.userInfo?.role?.id === 5)

  function handleNavigate(subPage, folder = null) {
    navigate(`/requests/${subPage}${folder ? `?folder=${folder}` : ""}`)
  }

  useEffect(() => {
    //document.title = 'Requests - Chargeback'
    /*if (hash) {
      if (!/enrollments|descriptors|auto_refund|integrations/i.test(hash)) {
        navigate(`/requests/enrollments?folder=new`)
      }
    }*/
  }, [hash])

  useEffect(() => {
    if (isRestrictedVerifiInformAdmin && hash === "verifi_inform") {
      navigate("/requests/enrollments?folder=new", { replace: true })
    }
  }, [hash, isRestrictedVerifiInformAdmin, navigate])

  const content = {
    enrollments: <RequestsEnrollments />,
    // descriptors: <RequestsDescriptors/>,
    auto_refund: <RequestsAutoRefund />,
    integrations: <RequestsIntegrations />,
    credits: <CreditsPage />,
    gift: <RequestsGifts />,
    withdrawal: <RequestsWithdrawal />,
    verifi_inform: <RequestsVerifiInform />
  }

  const visibleTabsList = useMemo(
    () =>
      isRestrictedVerifiInformAdmin
        ? tabsList.filter((tab) => tab.id !== "verifi_inform")
        : tabsList,
    [isRestrictedVerifiInformAdmin]
  )

  const items = useMemo(
    () =>
      visibleTabsList.map((tab) => ({
        key: tab.id,
        showArrow: false,
        label: (
          <ButtonComponent
            type="text"
            size="large"
            //onClick={() => handleNavigate(tab.id, tab?.options?.[0]?.id || null)}
            onClick={() => handleNavigate(tab.id)}
            className={cls("flex", {
              with_arrow: tab?.options?.length,
              with_arrow_active: hash === tab.id,
              active: hash === tab.id && !folder
            })}
            icon={tab.icon ? <Icon type={tab.icon} /> : <span />}
            block
          >
            <Text
              type={hash === tab.id && !folder ? "" : "secondary"}
              ellipsis={{ tooltip: tab.text }}
              style={{ marginRight: "auto" }}
            >
              {tab.text}
            </Text>
            {tab?.options?.length ? (
              <Flex>
                <Tag
                  color="processing"
                  bordered={false}
                  style={{ margin: "0 8px", padding: 0, background: "none", border: "none" }}
                >
                  {statistics?.[`${tab.id}_counter`]?.["all"] || 0}
                </Tag>
                <Icon type="chevron_down_small" className="arrow-icon" />
              </Flex>
            ) : (
              <Text type="secondary" style={{ fontSize: 12 }}>
                {statistics?.[`${tab.id}_counter`] || 0}
              </Text>
            )}
          </ButtonComponent>
        ),
        children: (
          <Flex vertical={true} gap={4}>
            {tab?.options?.map((el) => {
              let isActive = hash === tab.id && folder === el.id
              let count = statistics?.[`${tab.id}_counter`]?.[el.id] || "-"
              return (
                <ButtonComponent
                  key={el.id}
                  type="text"
                  size="large"
                  onClick={() => handleNavigate(tab.id, el?.id)}
                  className={cls("flex", { active: isActive })}
                  block
                >
                  <Paragraph
                    type={isActive ? "" : "secondary"}
                    ellipsis={{ tooltip: el.text, symbol: "...", rows: 1 }}
                    style={{ marginRight: "auto", marginBottom: 0 }}
                  >
                    {el.text}
                  </Paragraph>
                  {el?.id === "new" ? (
                    <Tag
                      color="processing"
                      bordered={false}
                      style={{
                        margin: "0 0 0 8px",
                        padding: 0,
                        background: "none",
                        border: "none"
                      }}
                    >
                      {count}
                    </Tag>
                  ) : (
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {count}
                    </Text>
                  )}
                </ButtonComponent>
              )
            })}
          </Flex>
        ),
        styles: { header: { padding: "4px 0" }, body: { padding: "0 0 0 28px" } }
      })),
    [hash, folder, statistics, visibleTabsList]
  )

  return (
    <div className={"settings-page"}>
      <div className="sider">
        <Title level={3} style={{ textAlign: "left", marginBottom: 24 }}>
          Requests
        </Title>

        <Collapse ghost={true} items={items} activeKey={hash} />
      </div>
      <div className={cls("content", "requests")}>
        <Spin spinning={businessAccountFetching}>{content[hash]}</Spin>
      </div>
      <AddCommentRequestModal requestType={hash} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  statistics: state.businessAccounts.statistics,
  businessAccountFetching: state.user.businessAccountFetching,
  theme: state.nav.theme
})

export default connect(mapStateToProps, null)(RequestsPage)
